export default {"src":"/_next/static/media/ML.ff56fc01.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};